import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';
import { convertMidRelatedRecommendGoodsItemToGoodsData } from '../utils/convertMidRelatedGoodsItemToGoodsData';
import { useSameMarketRecommendOnly } from '../../../hooks/useSameMarketRecommendOnly';

export const useMidRelatedRecommendGoodsList = () => {
  const goodsSno = useGoodsSno();
  // 기획전 이벤트 연관상품 off 실험: 타 마켓 연관 추천 광고는 요청하지 않는다.
  const sameMarketRecommendOnly = useSameMarketRecommendOnly();

  return useQuery({
    queryKey: queryKey.goodsMidRelatedRecommend(goodsSno),
    queryFn: () => goodsService.getMidRelatedAdGoods(goodsSno),
    select: data => {
      return {
        ...data,
        item_list: data.item_list.map(
          convertMidRelatedRecommendGoodsItemToGoodsData,
        ),
      };
    },
    enabled: !sameMarketRecommendOnly,
  });
};
